<script setup lang="ts">
import { type PropType } from 'vue'

enum TypeButton {
	Primary = 'primary',
	Secondary = 'secondary',
	Disabled = 'disabled',
}

const props = defineProps({
	type: {
		type: String as PropType<`${TypeButton}`>,
		default: TypeButton.Primary,
	},
	text: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['onClick'])

const handleClick = () => {
	if (props.type === TypeButton.Disabled) return
	emit('onClick')
}
</script>

<template>
	<div>
		<button :class="['bs-text-button', type]" @click="handleClick">
			{{ text }}
		</button>
	</div>
</template>
